export default {
    modal: {
        actEnd: {
            title: '活動已結束',
            desc: '您可前往活動中心查看更多活動',
            btn: '參與更多精彩活動'
        },
        noCrowd: {
            title: '本活動僅對部分用戶開放',
            desc: '參與更多精彩活動',
            btn: '去看看'
        }
    },
    message: {
        sendSuccess: '恭喜 獲得獎賞'
    }
};
